import React from 'react';

import {
  useGetFlirtAccountSetupQuery,
} from 'app/api/mainApi';
import {
  Container,
  Stepper,
  Step,
  StepLabel,
  Button,
  Link,
  Box,
} from '@mui/material';

const steps = {
  add_phone: 'Add Phone Number',
  add_cc: 'Add a credit card',
  verify_id: 'ID Verification',
  add_payout_info: 'Payout Info',
};

const FlirtAccountSetupContainer = () => {
  const { data: flirtAccountSetup } = useGetFlirtAccountSetupQuery();
  const stepsKeys = Object.keys(steps);
  const activeStep = stepsKeys.includes(flirtAccountSetup?.step) ? stepsKeys.indexOf(flirtAccountSetup.step) : 0;

  return (
    <Container maxWidth="lg">
      <Box sx={{ padding: 2 }} mt={5}>
        <h1>Set Up Your Flirt Account</h1>

        <Stepper activeStep={activeStep} alternativeLabel sx={{ marginBottom: 4 }}>
          {Object.entries(steps).map(([key, label], index) => (
            <Step key={key}>
              <StepLabel>
                {label}
                {activeStep === index && (
                  <Box sx={{ textAlign: 'center', marginTop: 2 }}>
                    <Button variant="contained" color="primary">
                      {index === 0 ? 'Start' : 'Next'}
                    </Button>
                  </Box>
                )}
              </StepLabel>
            </Step>
          ))}
        </Stepper>

        <Box sx={{ textAlign: 'center', marginTop: 10 }}>
          <Link href="#" underline="hover">
            Why all these steps blah blah?
          </Link>
        </Box>
      </Box>
    </Container>
  );
};

export default FlirtAccountSetupContainer;
